var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-footer"},[_c('van-button',{attrs:{"type":"warning","plain":""},on:{"click":_vm.handleCancel}},[_vm._v("取消")]),_c('van-button',{attrs:{"type":"warning","disabled":!_vm.twoIds.length},on:{"click":_vm.handleConfirm}},[_vm._v("确认配置")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }